// useClearStorage.js
import { useEffect } from "react";

export const useClearStorage = () => {
  useEffect(() => {
    const removeKeys = (keys, storage) => {
      keys.forEach((key) => storage.removeItem(key));
    };
    const commonLocalKeys = [
      "UpdationMode",
      "displayBusinessName",
      "agentName",
      "agentGender",
      "agentLanguageCode",
      "agentLanguage",
      "llmId",
      "agent_id",
      "knowledgeBaseId",
      "agentRole",
      "agentVoice",
      "agentVoiceAccent",
      "avatar",
      "googleUrl",
      "webUrl",
      "aboutBusiness",
      "additionalInstruction",
      "knowledge_base_name",
      "knowledge_base_id",
      "selectedAgentAvatar",
      "bId",
      "UpdationModeStepWise",
      "allPlans",
      "hasHandledThankYou",
      "checkPage2",
      "paymentDone",
      "subcriptionIdUrl",
      "refreshSelectedSiteMapUrls",
      "websiteValidatedUrl",
      "state",
      "sitemapSelectionInitialized",
      "showNoGMBCheckbox",
      "viewSiteMap",
      "urls"
    ];

    const commonSessionKeys = [
      "UpdationMode",
      "agentName",
      "agentGender",
      "agentLanguageCode",
      "agentLanguage",
      "llmId",
      "agent_id",
      "knowledgeBaseId",
      "googleListing",
      "displayBusinessName",
      "aboutBusinessForm",
      "agentRole",
      "agentVoice",
      "agentVoiceAccent",
      "avatar",
      "businessDetails",
      "businessId",
      "businesServices",
      "businessLocation",
      "selectedCustomServices",
      "bId",
      "completedSteps",
      "currentStep",
      "avtarChecked",
      "selectedLang",
      "agentStatus",
      "selectedfilterOption",
      "placeDetailsExtract",
      "agentNote",
      "prevBuisnessType",
      "prevAgentGender",
      "UpdationModeStepWise",
      "customServices",
      "agentCode",
      "businessUrl",
      "selectedServices",
      "selectedPlan",
      "currentAgentPlan",
      "updateBtn",
      "checkPage",
      "VoiceAgentName",
      "selectedLangCode",
      "AgentCode",
      "priceId",
      "price",
      "selectedSiteMapUrls",
      "urls",
      "chat_agent_id",
      "chat_llm_id",
      "chatWebWidget",
      "subType",
      "assignedPhoneNumber",
      "selectedSiteMapUrls",
      "scrapedUrls",
      "refreshSelectedSiteMapUrls",
      "websiteValidatedUrl",
      "state",
      "sitemapSelectionInitialized",
      "showNoGMBCheckbox",
      "timezone",
      "sitemapUrls",
      "selectedSiteMapUrls_backup",
      "referredByName",
      "referredBy",
      "placeDetails",
      "phone",
      "personalDetailsAnimationPlayed",
      "otp",
      "noGoogleListing",
      "naviateFrom",
      "googleListing",
      "businessType",
      "businessSubtype",
      "selectedCarrier",
      "viewSiteMap",
      "agent_creation_method",
      "agentGeneralTools",
      "callRecording",
      "selectedSitemapUrls",
      "userCalApiKey",
      "noBusinessWebsite",
      "customBusiness",
      "onboardingMode",
      "isAgentCreated"

    ];

    // EXTRA KEYS only removed if UpdationMode === ON
    const modeSpecificLocalKeys = [];
    const modeSpecificSessionKeys = [];

    const isUpdateOn =
      localStorage.getItem("UpdationMode") === "ON" ||
      sessionStorage.getItem("UpdationMode") === "ON";

    if (isUpdateOn) {
      removeKeys(modeSpecificLocalKeys, localStorage);
      removeKeys(modeSpecificSessionKeys, sessionStorage);
    }

    // ALWAYS remove common keys
    removeKeys(commonLocalKeys, localStorage);
    removeKeys(commonSessionKeys, sessionStorage);
  }, []);
};
